import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import * as React from 'react';
import s from './solution-rate-reviews.scss';
import { withMarketplaceStore, } from '../../../../component-decorators/with-marketplace-store';
import { getIsEligibleForReviews, getReviewesBySolutionId } from '../../../../api/api';
import { SolutionRate, dtoToSolutionRateProps, } from './solution-rate/solution-rate';
import { dtoToSolutionReviews, SolutionReviews, } from './solution-reviews/solution-reviews';
import { NoReviews } from '.';
import { ReviewsSortBy } from '../../../../enums/marketplace-enums';
import { biLogger } from '../../../../bi/logger';
import { withExperiments } from '../../../../component-decorators/with-experiments';
var SolutionRateReviewsContainer = /** @class */ (function (_super) {
    __extends(SolutionRateReviewsContainer, _super);
    function SolutionRateReviewsContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.getReviewsBySortMethod = function (sortMethod) { return __awaiter(_this, void 0, void 0, function () {
            var solutionId, limit, offset, sortBy, reviewsDto, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        solutionId = this.props.solutionId;
                        limit = 5;
                        offset = 0;
                        sortBy = sortMethod;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, getReviewesBySolutionId(solutionId, sortBy, offset, limit)];
                    case 2:
                        reviewsDto = _c.sent();
                        ((_b = (_a = reviewsDto === null || reviewsDto === void 0 ? void 0 : reviewsDto.body) === null || _a === void 0 ? void 0 : _a.reviews) === null || _b === void 0 ? void 0 : _b.length) &&
                            this.setState({
                                endOfReviews: limit >= reviewsDto.body.totalReviews,
                                reviews: dtoToSolutionReviews(reviewsDto),
                                reviewsOffset: limit,
                                sortReviewsBy: sortMethod,
                            });
                        return [4 /*yield*/, this.sendSortClickedBi(solutionId, sortMethod)];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _c.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            isFetching: false,
            reviewsOffset: 0,
            endOfReviews: false,
            sortReviewsBy: ReviewsSortBy.MostRecent,
            reviews: [],
        };
        _this.loadMoreReviews = _this.loadMoreReviews.bind(_this);
        _this.getReviewsBySortMethod = _this.getReviewsBySortMethod.bind(_this);
        _this.initialize = _this.initialize.bind(_this);
        return _this;
    }
    SolutionRateReviewsContainer.prototype.render = function () {
        var _this = this;
        var solutionRateChartsProps = this.state.solutionRateChartsProps;
        return (React.createElement("div", { "data-testid": "rate-and-reviews" }, this.state.isFetching ? null : this.state.noReviews ||
            this.props.showEmptyState ? (React.createElement(NoReviews, { isEligibleForReviews: this.state.isEligibleForReviews, appId: this.props.solutionId })) : (React.createElement("div", { className: s.solutionRateReviewsContainer, id: "reviews" },
            React.createElement(SolutionRate, __assign({}, this.state.solutionRateChartsProps)),
            React.createElement(SolutionReviews, { averageRating: solutionRateChartsProps && solutionRateChartsProps.reviewStars, appName: this.props.appName, afterPostRender: function () {
                    return _this.initialize(_this.state.reviewsOffset + 1, ReviewsSortBy.MostRecent);
                }, editMode: this.state.editMode, showDeletedLink: this.state.showDeletedText, loadMore: this.loadMoreReviews, sortBy: this.getReviewsBySortMethod, reviews: this.state.reviews, hideLoadMoreBtn: this.state.endOfReviews, developerName: this.props.developerName, developerIcon: this.props.developerIcon, numberOfReviews: this.state.numberOfReviews, isEligibleForReviews: this.state.isEligibleForReviews, appId: this.props.solutionId })))));
    };
    SolutionRateReviewsContainer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.props.showEmptyState) {
                    this.props.solutionId && this.initialize();
                }
                return [2 /*return*/];
            });
        });
    };
    SolutionRateReviewsContainer.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (prevProps !== this.props &&
                    this.props.solutionId &&
                    prevProps.solutionId &&
                    prevProps.solutionId !== this.props.solutionId) {
                    this.initialize();
                }
                return [2 /*return*/];
            });
        });
    };
    SolutionRateReviewsContainer.prototype.initialize = function (limit, afterPostSort) {
        var _a, _b;
        if (limit === void 0) { limit = 5; }
        return __awaiter(this, void 0, void 0, function () {
            var solutionId, offset, sortBy, _c, reviewsDto, isEligibleForReviews;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        solutionId = this.props.solutionId;
                        offset = 0;
                        sortBy = afterPostSort || this.state.sortReviewsBy;
                        return [4 /*yield*/, Promise.all([
                                getReviewesBySolutionId(solutionId, sortBy, offset, limit),
                                getIsEligibleForReviews(solutionId),
                            ]).catch(function (error) { return [[], true]; })];
                    case 1:
                        _c = _d.sent(), reviewsDto = _c[0], isEligibleForReviews = _c[1];
                        if (reviewsDto && ((_b = (_a = reviewsDto === null || reviewsDto === void 0 ? void 0 : reviewsDto.body) === null || _a === void 0 ? void 0 : _a.reviews) === null || _b === void 0 ? void 0 : _b.length)) {
                            this.setState(function (prevState) {
                                var _a, _b;
                                var newReviews = dtoToSolutionReviews(reviewsDto);
                                return {
                                    noReviews: ((_b = (_a = reviewsDto === null || reviewsDto === void 0 ? void 0 : reviewsDto.body) === null || _a === void 0 ? void 0 : _a.reviews) === null || _b === void 0 ? void 0 : _b.length) === 0,
                                    isFetching: false,
                                    editMode: shouldShowEditLink(reviewsDto),
                                    showDeletedText: shouldShowDeleteLink(reviewsDto),
                                    endOfReviews: limit >= reviewsDto.body.totalReviews,
                                    solutionRateChartsProps: dtoToSolutionRateProps(reviewsDto),
                                    reviews: newReviews,
                                    numberOfReviews: reviewsDto.body.totalReviews,
                                    reviewsOffset: Math.min(limit, reviewsDto.body.totalReviews),
                                    isEligibleForReviews: isEligibleForReviews,
                                };
                            });
                        }
                        else {
                            this.setState({
                                noReviews: true,
                                isEligibleForReviews: isEligibleForReviews,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SolutionRateReviewsContainer.prototype.loadMoreReviews = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var solutionId, limit, offset, sortBy, res, reviewsDto_1, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        solutionId = this.props.solutionId;
                        limit = 5;
                        offset = this.state.reviewsOffset;
                        sortBy = this.state.sortReviewsBy;
                        return [4 /*yield*/, biLogger.appMarketAppPageReadMoreReviewsClick({
                                app_id: solutionId,
                                tag_name: 'app_page',
                            })];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, getReviewesBySolutionId(solutionId, sortBy, offset, limit)];
                    case 3:
                        res = _c.sent();
                        reviewsDto_1 = res;
                        ((_b = (_a = reviewsDto_1 === null || reviewsDto_1 === void 0 ? void 0 : reviewsDto_1.body) === null || _a === void 0 ? void 0 : _a.reviews) === null || _b === void 0 ? void 0 : _b.length) &&
                            this.setState(function (prevState) {
                                var newReviews = dtoToSolutionReviews(reviewsDto_1);
                                return {
                                    endOfReviews: prevState.reviewsOffset + limit >= reviewsDto_1.body.totalReviews,
                                    reviews: prevState.reviews.concat(newReviews),
                                    reviewsOffset: prevState.reviewsOffset + limit,
                                };
                            });
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _c.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SolutionRateReviewsContainer.prototype.sendSortClickedBi = function (solutionId, sortMethod) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // tslint:disable-next-line: no-floating-promises
                return [2 /*return*/, biLogger.appMarketSortReviews({
                        appId: solutionId,
                        value: biParamsRenaming(sortMethod),
                    })];
            });
        });
    };
    SolutionRateReviewsContainer = __decorate([
        withMarketplaceStore,
        withExperiments
    ], SolutionRateReviewsContainer);
    return SolutionRateReviewsContainer;
}(React.Component));
export { SolutionRateReviewsContainer };
var biParamsRenaming = function (key) {
    return key === ReviewsSortBy.MostHelpful
        ? 'most_helpful'
        : key === ReviewsSortBy.MostRecent
            ? 'most_recent'
            : key === ReviewsSortBy.Rating
                ? 'most_rated'
                : '';
};
var shouldShowDeleteLink = function (reviewDto) {
    var userReview = reviewDto.body && reviewDto.body.userReview;
    return userReview && !userReview.publishedAt;
};
var shouldShowEditLink = function (reviewDto) {
    var userReview = reviewDto.body && reviewDto.body.userReview;
    var shouldDisplay = userReview && !!userReview && !!userReview.publishedAt;
    return {
        userReview: userReview,
        shouldDisplay: shouldDisplay,
    };
};
//# sourceMappingURL=solution-rate-reviews-container.js.map